exports = module.exports = require("../../../node_modules/_css-loader@0.28.7@css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".about-child .ys-fengcai {\n  padding: 0 116px; }\n  .about-child .ys-fengcai .section {\n    margin-bottom: 20px; }\n  .about-child .ys-fengcai .common-title {\n    font-size: 18px;\n    color: #333;\n    text-align: left;\n    margin-bottom: 10px; }\n  .about-child .ys-fengcai img {\n    display: block; }\n    .about-child .ys-fengcai img + img {\n      margin-top: 20px; }\n    .about-child .ys-fengcai img + .common-title {\n      margin-top: 20px; }\n  .about-child .ys-fengcai .left-contain,\n  .about-child .ys-fengcai .right-contain {\n    vertical-align: top;\n    display: inline-block;\n    width: 450px; }\n    .about-child .ys-fengcai .left-contain img,\n    .about-child .ys-fengcai .right-contain img {\n      display: block;\n      margin: 0 auto;\n      width: 200px; }\n  .about-child .ys-fengcai .zc-title {\n    font-size: 18px; }\n\n.about-child .ys-img img {\n  width: 968px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/_css-loader@0.28.7@css-loader!./node_modules/_sass-loader@6.0.7@sass-loader/lib/loader.js!./src/components/other/other.scss
// module id = 776
// module chunks = 0